import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class App1WrapperService {

  constructor(
    public router: Router,
    //public handleHttpErrorService: HandleHttpErrorService
  ) { }
}
